module.exports = __webpack_public_path__ + "newprotal/img/qr2.e30cf661.jpg";